import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { devtoolsReduxEnhancer, sentryReduxEnhancer } from './enhancers';
import { rootReducer } from './reducers';
export const actionToPlainObject = () => (next) => (action) => next(Object.assign({}, action));
// We could import pre-hydrated data as the second param here
export const store = createStore(rootReducer, compose(applyMiddleware(thunk, actionToPlainObject), devtoolsReduxEnhancer, sentryReduxEnhancer));
